import { defineElement } from '@webtides/element-js';
import SpecListFilter from './spec-list-filter.class';

defineElement('spec-list-filter', SpecListFilter);
